<template>
  <div class="rbu-section-fluctuation-editor elevation-2">
    <ContractRbuSectionFluctuationModule
      v-for="(module, moduleIdx) in modules"
      :key="moduleIdx"
      :section="section"
      :module="module"
      :idx="moduleIdx"
      @update="onModuleUpdate(moduleIdx, $event)"
      @delete="removeModule(moduleIdx)"
    ></ContractRbuSectionFluctuationModule>
    <v-card-actions style="background-color: #ffffff">
      <v-btn color="primary" outlined @click="addModule">Add Module </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import ContractRbuSectionFluctuationModule from "@/components/contract/ContractRbuSectionFluctuationModule.vue";

export default {
  name: "ContractRbuSectionFluctuationEditor",
  components: { ContractRbuSectionFluctuationModule },
  props: {
    value: Array,
    section: Object,
  },
  setup(props, { root, emit }) {
    const modules = ref(props.value || []);
    watch(
      () => props.value,
      (newValue) => {
        modules.value = newValue;
      }
    );
    const addModule = function () {
      modules.value.push({
        order_no: modules.value.length,
        ignored: false,
        portion: 100,
        adjustment_value_first: true,
        adjustment_percentage: 100,
        adjustment_percentage_formula: "",
        adjustment_value: 0,
        adjustment_value_formula: "",
        sub_total: 0,

        fluctuations: [
          {
            previous_period: "BASE_START",
            current_period: "BASE_END",
          },
        ],
      });
    };
    const onModuleUpdate = function (moduleIdx, m) {
      modules.value.splice(moduleIdx, 1, m);
    };
    const removeModule = function (moduleIdx) {
      modules.value.splice(moduleIdx, 1);
    };

    const addFluctuation = function (moduleIdx) {
      modules.value[moduleIdx].fluctuations.push({
        previous_period: "BASE_START",
        current_period: "BASE_END",
      });
    };
    const updateFluctuation = function (moduleIdx, fluctuationIdx, f) {
      const original = modules.value[moduleIdx].fluctuations[fluctuationIdx];
      modules.value[moduleIdx].fluctuations.splice(fluctuationIdx, 1, {
        ...original,
        ...f,
      });
    };
    const deleteFluctuation = function (moduleIdx, fluctuationIdx) {
      modules.value[moduleIdx].fluctuations.splice(fluctuationIdx, 1);
    };

    watch(
      () => modules.value,
      (newValue) => {
        emit("input", newValue);
      },
      { deep: true }
    );

    return {
      modules,
      addModule,
      onModuleUpdate,
      removeModule,
      addFluctuation,
      updateFluctuation,
      deleteFluctuation,
    };
  },
};
</script>

<style lang="less">
.rbu-section-fluctuation-editor {
  flex: 0 0 auto;
  background-color: lightgray;
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;

  .rbu-section-fluctuation-module {
    background-color: white;
    padding: 12px;
    display: flex;
    flex-direction: column;

    .rbu-section-fluctuation-module-header {
      display: flex;

      .ignore-checkbox {
        i,
        label {
          color: var(--v-primary-base);
        }
      }
    }
  }
}
</style>
